import React, { Component } from 'react'
import { Grid, Row, Col } from 'react-bootstrap'
import { Helmet } from 'react-helmet'
import Footer from './Footer'
import { getInitialData } from '../../helpers'
import './static.css'

class Contact extends Component {
  constructor(props) {
    super(props)
    this.content = getInitialData('kontakt')
  }

  render() {
    return (
      <Grid className="static-page contact-page">
        <Helmet>
          <title>Kontakt - SPÝTAJ SA VAŠICH 68</title>
        </Helmet>
        <Row>
          <Col xs={12}>
            <h1>Kontakt</h1>
          </Col>
        </Row>
        <Row>
          <Col className="content" md={8}>
            <div className="card" dangerouslySetInnerHTML={{ __html: this.content }} />
            <Footer />
          </Col>
        </Row>
      </Grid>
    )
  }
}

export default Contact



// WEBPACK FOOTER //
// ./src/components/Static/Contact.js